import { SaveButton } from '@rd-web-markets/shared/dist/util/buttons';
import React, { useState } from 'react';
import { Form, Row, Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
const CustomerContractForm = _ref => {
  let {
    loading,
    onSubmit
  } = _ref;
  const {
    t
  } = useTranslation();
  const UPSTREAM_CONTRACT_OPTIONS = [{
    value: 'received',
    label: t('received')
  }, {
    value: 'review_in_progress',
    label: t('review_in_progress')
  }, {
    value: 'reviewed',
    label: t('reviewed')
  }];
  const UPSTREAM_REVIEW_OPTIONS = [{
    value: 'nq',
    label: t('nq')
  }, {
    value: 'inconclusive',
    label: t('inconclusive')
  }, {
    value: 'q',
    label: t('q')
  }];
  const [form, setForm] = useState({
    details: '',
    upstream_contract: '',
    upstream_review: ''
  });
  const allFieldsFilled = form.details.trim() !== '' && form.upstream_contract.trim() !== '' && form.upstream_review.trim() !== '';
  const handleChange = e => {
    const {
      name,
      value
    } = e.target;
    setForm({
      ...form,
      [name]: value
    });
  };
  const handleSubmit = async () => {
    if (!allFieldsFilled) return;
    if (onSubmit) {
      await onSubmit(form);
    }
    setForm({
      details: '',
      upstream_contract: '',
      upstream_review: ''
    });
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "p-3 border rounded mb-4 bg-light"
  }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React.createElement(Form.Group, {
    controlId: "details",
    className: "mb-3"
  }, /*#__PURE__*/React.createElement(Form.Label, null, t('contract_details')), /*#__PURE__*/React.createElement(Form.Control, {
    type: "text",
    name: "details",
    value: form.details,
    onChange: handleChange,
    placeholder: t('enter_contract_details')
  })))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React.createElement(Form.Group, {
    controlId: "upstream_contract",
    className: "mb-3"
  }, /*#__PURE__*/React.createElement(Form.Label, null, t('upstream_contract')), /*#__PURE__*/React.createElement(Form.Select, {
    name: "upstream_contract",
    value: form.upstream_contract,
    onChange: handleChange
  }, /*#__PURE__*/React.createElement("option", {
    value: ""
  }, t('select_upstream_contract')), UPSTREAM_CONTRACT_OPTIONS.map(option => /*#__PURE__*/React.createElement("option", {
    key: option.value,
    value: option.value
  }, option.label))))), /*#__PURE__*/React.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React.createElement(Form.Group, {
    controlId: "upstream_review",
    className: "mb-3"
  }, /*#__PURE__*/React.createElement(Form.Label, null, t('upstream_review')), /*#__PURE__*/React.createElement(Form.Select, {
    name: "upstream_review",
    value: form.upstream_review,
    onChange: handleChange
  }, /*#__PURE__*/React.createElement("option", {
    value: ""
  }, t('select_upstream_review')), UPSTREAM_REVIEW_OPTIONS.map(option => /*#__PURE__*/React.createElement("option", {
    key: option.value,
    value: option.value
  }, option.label)))))), /*#__PURE__*/React.createElement("div", {
    className: "d-flex justify-content-end"
  }, /*#__PURE__*/React.createElement(SaveButton, {
    onClick: handleSubmit,
    disabled: !allFieldsFilled || loading,
    text: loading ? t('creating') : t('create')
  })));
};
export default CustomerContractForm;